import moment from 'moment';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { UnmountClosed } from 'react-collapse';
import styled from 'styled-components';
import {
  calucateTotalPriceForSectors,
  formatPrice,
  getProp,
  __,
} from '../../utilities';
import Button from '../Button';
import Icon from '../Icon';
import Loader from '../Loader';
import StopDetail from './stopDetail';
import Transfer from './transfer';

const Wrapper = styled.div`
  position: relative;
  box-shadow: ${({ theme }) => theme.shadow};
  background-color: #fff;
  min-height: ${rem(190)};
  padding: ${rem(30)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
  border-left: ${rem(4)} solid
    ${({ selected, theme }) => (selected ? theme.color.primary : 'transparent')};
  border-bottom: ${rem(1)} solid ${({ theme }) => theme.color.delimiter};
  ${({ theme }) => theme.media.sm`
    flex-direction: row;
  `};
  @media screen and (max-width: 486px) {
    padding: ${rem(10)};
  }
`;

const StyledButton = styled(Button)`
  margin-top: ${rem(4)};
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ColPrice = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: initial;
`;

const Count = styled.div`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.color.font.primary};
  text-align: center;
  margin-bottom: 0.3rem;
`;

const Price = styled.div`
  color: ${({ theme }) => theme.color.primary};
  font-size: ${rem(32)};
  font-weight: bold;
  text-align: center;
`;

const UnitPrice = styled.div`
  color: ${({ theme }) => theme.color.font.secondary};
  font-size: ${rem(12)};
  text-align: center;
`;

const Duration = styled.div`
  font-size: ${rem(14)};
  font-weight: bold;
  color: ${({ theme }) => theme.color.font.secondary};
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(10)};
  align-items: center;
  ${({ theme }) => theme.media.sm`
    margin-bottom: 0;
  `};
`;

const TransferText = styled.span`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const TransferDetail = styled.div`
  display: flex;
  align-items: center;
  margin: ${rem(20)} 0;
  padding-left: 0;
  margin-left: 0;
  border-left: none;
  font-size: ${rem(14)};
  justify-content: center;
  letter-spacing: 0.1px;
  min-height: ${rem(25)};
  color: ${({ theme }) => theme.color.font.secondary};
  ${({ theme, noBorder }) => theme.media.sm`
    justify-content: initial;
    margin: ${rem(14)} 0;
    padding-left: ${rem(25)};
    margin-left: ${rem(7)};
    border-left: ${rem(2)} dotted ${
    noBorder ? 'transparent' : theme.color.font.primary
  };
  `};
`;

const CustomTransferDetail = styled(TransferDetail)`
  padding: ${rem(13)};
  padding-left: ${rem(25)};
`;

export const SIcon = styled(Icon)`
  margin-right: ${rem(10)};
`;

const formatCount = param => {
  const count = parseInt(param, 0);
  if (count === 1) {
    return `${count} ${__('cestujúci')}`;
  } else if (count > 1 && count < 5) {
    return `${count} ${__('cestujúci')}`;
  }
  return `${count} ${__('cestujúcich')}`;
};

const formatDate = date => {
  const { days, hours, minutes, months, years } = date;

  return `${years > 0 ? `${years} r ` : ''}${months > 0 ? `${months} m ` : ''}${
    days > 0 ? `${days} ${__('dni')} ` : ''
  }${hours > 0 ? `${hours} ${__('hod')} ` : ''}${
    minutes > 0 ? `${minutes} ${__('min')}` : ''
  }`;
};

const formatTransfer = param => {
  const count = parseInt(param, 0);
  if (count === 0) {
    return __('bez prestupu');
  } else if (count === 1) {
    return `${count} ${__('prestup')}`;
  }
  return `${count} ${__('prestupov')}`;
};

const Labels = styled.div`
  display: flex;
  position: absolute;
  top: -${rem(19)};
  right: 0;
  margin-right: -1.125rem;
  ${({ theme }) => theme.media.sm`
    margin-right: ${rem(30)};
  `};
`;

const Label = styled.div`
  color: ${({ theme }) => theme.color.font.primary};
  letter-spacing: 0.1px;
  font-weight: 500;
  margin-left: ${rem(10)};
  font-size: ${rem(14)};
  box-shadow: ${({ theme }) => theme.shadow};
  padding: ${rem(8)} ${rem(14)};
  background-color: #fff;
  border-radius: ${({ theme }) => theme.borderRadius};
`;

// const CheckedLabel = styled(Label) `
//   background-color: ${({ theme }) => theme.color.secondary};
// `;

const CheapestLabel = styled(Label)``;

const TopSpeedLabel = styled(Label)``;

const Close = styled.div`
  color: ${({ theme }) => theme.color.font.secondary};
  margin-top: ${rem(30)};
  font-size: ${rem(14)};
  margin-left: ${rem(27)};
  &:hover {
    cursor: pointer;
  }
`;

const formatFreeSteaings = param => {
  const count = parseInt(param, 0);
  if (count === 1) {
    return `${count} ${__('voľné miesto')}`;
  } else if (count > 1 && count < 5) {
    return `${count} ${__('voľné miesta')}`;
  }
  return `${count} ${__('voľných miest')}`;
};

const formatDateDiff = (date1, date2) => {
  const date1Moment = moment(date1);
  const date2Moment = moment(date2);
  const diffInMins = moment.duration(date2Moment.diff(date1Moment));
  return formatDate(diffInMins._data);
};

class TravelRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.handleClickWay = this.handleClickWay.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleClickRow = this.handleClickRow.bind(this);
  }

  getUnitPrice() {
    return calucateTotalPriceForSectors(
      getProp(this.props, ['data', 'sectors'], []),
    );
  }

  formatPrice(price) {
    let round = 2;
    if (price) {
      if (price % 1 === 0) {
        round = 0;
      }
      return formatPrice(price, 'EUR', round);
    }
    return null;
  }

  handleClickRow(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      isOpen: false,
    });
  }

  handleClickWay(e) {
    e.preventDefault();
    e.stopPropagation();
    const { onClick, index, data: { sectors, id_connect } } = this.props; // eslint-disable-line camelcase
    const sectorsIds = sectors.reduce((prev, sector) => {
      return [
        ...prev,
        {
          id: sector.id_dps,
          from: sector.from_id_bus_stop,
          to: sector.to_id_bus_stop,
        },
      ];
    }, []);
    onClick(index, sectorsIds, id_connect);
    this.setState({ isOpen: true });
  }

  handleNext() {
    const { data: { sectors } } = this.props;
    const sectorsIds = sectors.reduce((prev, sector) => {
      return [...prev, sector.id_dps];
    }, []);
    this.props.onClickNext(
      getProp(this.props, ['data', 'id_connect']),
      sectorsIds,
    );
  }

  render() {
    const { isOpen } = this.state;
    const {
      way1Date,
      topSpeed,
      cheapest,
      selected,
      count,
      isFetching,
      data: {
        time_utc_name: timeUtcName,
        time_utc_ident: timeUtcIdent,
        time_dest_utc_ident: timeDestUtcIdent,
        time_dest_utc_name: timeDestUtcName,
        bus_change: busChange,
        datetime,
        datetime_dest: datetimeDest, // eslint-disable-line camelcase
        av_count: avCount, // eslint-disable-line camelcase
        sectors,
      },
    } = this.props;

    let stopSale = false;
    sectors.forEach(sector => {
      if (sector.stop_sale) {
        stopSale = true;
        return null;
      }
    });
    const sectorsInOrder = sectors.reduce((prev, sector) => {
      return [...prev, sector.id_dps];
    }, []);

    const dateFrom = moment(datetime);
    const freeSeatsCount = parseInt(avCount, 0);
    const dateTo = moment(datetimeDest);
    const diff = moment.duration(dateTo.diff(dateFrom));
    const diffFormated = formatDate(diff._data);
    const unitPrice = this.getUnitPrice();
    const formatedPrice = this.formatPrice(unitPrice * count);
    const formatedUnitPrice = this.formatPrice(unitPrice);
    let content = <div />;

    let dateBusIn = null;
    let dateBusOut = null;
    let dateBusInType = null;
    let dateBusOutType = null;
    let diffTime = null;
    let owner0 = '';
    let owner1 = '';

    const detail = getProp(this.props, ['connectionDetail', 'sectorsById'], {});
    sectorsInOrder.forEach((idSector, idx) => {
      const sector = sectors.find(s => s.id_dps === idSector);
      if (idx === 0) {
        dateBusIn = sector.datetime_dest;
        dateBusInType = sector.time_utc_ident;
        owner0 = getProp(sector, ['busses', 0, 'owner'], '');
      }
      if (idx === 1) {
        dateBusOut = sector.datetime;
        dateBusOutType = sector.time_utc_ident;
        owner1 = getProp(sector, ['busses', 0, 'owner'], '');
      }
      if (!!dateBusOut && !!dateBusIn) {
        diffTime = formatDateDiff(dateBusIn, dateBusOut);
      }
    });

    if (sectors.length === 1) {
      owner1 = owner0;
    }

    if (!selected || !isOpen) {
      content = (
        <div>
          <Transfer
            date={datetime}
            type={`${timeUtcIdent} - ${timeUtcName}`}
            selected={selected}
            stopName={this.props.from}
            owner={owner0}
          />
          <CustomTransferDetail>
            <TransferText onClick={this.handleClickWay}>
              {`${formatTransfer(
                getProp(this.props, ['data', 'sectors'], []).length - 1,
              )} - ${__('zobraziť celú trasu')}`}{' '}
              {diffTime && `(${__('prestup trvá')} ${diffTime})`}
            </TransferText>
          </CustomTransferDetail>
          <Transfer
            date={datetimeDest}
            type={`${timeDestUtcIdent} - ${timeDestUtcName}`}
            selected={selected}
            stopName={this.props.to}
            owner={owner1}
          />
        </div>
      );
    } else if (isFetching && Object.keys(detail).length === 0) {
      content = (
        <UnmountClosed isOpened={selected && isOpen}>
          <div>
            <Transfer
              type={`${timeUtcIdent} - ${timeUtcName}`}
              date={datetime}
              selected={selected}
              stopName={this.props.from}
              owner={owner0}
            />
            <TransferDetail>
              <div style={{ marginTop: rem(15) }}>
                <Loader size="xl" />
              </div>
            </TransferDetail>
            <Transfer
              date={datetimeDest}
              selected={selected}
              stopName={this.props.to}
              type={`${timeDestUtcIdent} - ${timeDestUtcName}`}
              owner={owner1}
            />
          </div>
        </UnmountClosed>
      );
    } else {
      content = (
        <UnmountClosed isOpened={selected && isOpen}>
          <div>
            <Transfer
              type={`${timeUtcIdent} - ${timeUtcName}`}
              date={datetime}
              selected={selected}
              stopName={this.props.from}
              dots
              owner={owner0}
            />
            <div style={{ marginTop: rem(25) }}>
              {sectorsInOrder.map((sector, idx) => {
                const stops = getProp(detail[sector], ['stops'], []);

                if (stops.length > 0) {
                  return stops.map((stop, index) => {
                    // nezobrazujeme prvu a poslednu zastavku odtial
                    if (
                      index !==
                        getProp(detail[sector], ['stops'], []).length - 1 &&
                      index !== 0
                    ) {
                      return (
                        <StopDetail
                          dateBusIn={dateBusIn}
                          dateBusInType={dateBusInType}
                          dateBusOut={dateBusOut}
                          dateBusOutType={dateBusOutType}
                          dateType={stop.time_utc_ident}
                          dateDiff={diffTime}
                          busChange={busChange}
                          sectorIndex={idx}
                          isLastSector={idx + 1 === Object.keys(detail).length}
                          name={stop.name}
                          date={stop.datetime_out || stop.datetime_in}
                          key={index.toString()}
                          isFirst={index === 0}
                          isLast={
                            index + 2 ===
                            getProp(detail[sector], ['stops'], []).length
                          }
                        />
                      );
                    }
                    return null;
                  });
                }
                return (
                  <TransferDetail noBorder>
                    <TransferText>
                      {__('Trasa neobsahuje žiadne medzizastávky')}
                    </TransferText>
                  </TransferDetail>
                );
              })}
            </div>
          </div>
          <Transfer
            type={`${timeDestUtcIdent} - ${timeDestUtcName}`}
            date={datetimeDest}
            selected={selected}
            stopName={this.props.to}
            owner={owner1}
          />
        </UnmountClosed>
      );
    }

    let diffOfTime = moment(datetime).diff(moment(way1Date));
    if (Number.isNaN(diffOfTime)) {
      diffOfTime = 0;
    }
    return (
      <Wrapper selected={selected}>
        <Labels>
          {cheapest && <CheapestLabel>{__('Najlacnejšie')}</CheapestLabel>}
          {topSpeed && <TopSpeedLabel>{__('Najrýchlejšie')}</TopSpeedLabel>}
        </Labels>
        <Col>
          {content}
          {!isFetching &&
            selected &&
            isOpen && (
              <Close onClick={this.props.onClose}>
                {__('Zatvoriť detail')}
              </Close>
            )}
        </Col>
        <ColPrice>
          {this.props.ticketType !== 'B' && (
            <React.Fragment>
              <Price>{formatedPrice}</Price>
              <UnitPrice>
                {formatedUnitPrice}/{__('pasažier')}
              </UnitPrice>
            </React.Fragment>
          )}
          <Count>
            {formatCount(count)} / {formatFreeSteaings(freeSeatsCount)}
          </Count>
          <Duration>
            <SIcon name="clock" color="secondary" /> {diffFormated}
          </Duration>
          {diffOfTime >= 0 ? (
            formatedPrice && freeSeatsCount >= count && !stopSale ? (
              <StyledButton primary onClick={this.handleNext}>
                {__('Pokračovať')}
              </StyledButton>
            ) : (
              <StyledButton primary disabled>
                {__('Nedostupné')}
              </StyledButton>
            )
          ) : (
            <StyledButton primary disabled>
              {__('Nedostupné')}
            </StyledButton>
          )}
        </ColPrice>
      </Wrapper>
    );
  }
}

export const dataProps = {
  datetime: PropTypes.string.isRequired,
  datetime_dest: PropTypes.string.isRequired,
  sectors: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
};

TravelRow.propTypes = {
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  data: PropTypes.shape({ ...dataProps }).isRequired,
  topSpeed: PropTypes.bool,
  cheapest: PropTypes.bool,
  selected: PropTypes.bool,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClickNext: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  connectionDetail: PropTypes.shape({}),
  from: PropTypes.string,
  to: PropTypes.string,
};

TravelRow.defaultProps = {
  topSpeed: false,
  from: null,
  to: null,
  cheapest: false,
  selected: false,
  isFetching: true,
  connectionDetail: {},
};

export default TravelRow;



// WEBPACK FOOTER //
// ./src/components/TravelRow/index.js